<form [formGroup]="formGroup" *ngIf="showGroup" appPropagateSubmit [parentFormGroupDirective]="parentFormGroupDirective" autocomplete="off">
  <div class="mt-3">
    <h6>Aufbau und Größe</h6>
    <div *ngIf="produktart !== produktarten.Eigenheim; else produktEigenheimInfo">Bitte geben Sie für die Ebenen die verbaute Fläche inkl. Gemäuer an (außen gemessen). Beim Wohnkeller nennen Sie bitte die Raumgröße.</div>
    <ng-template #produktEigenheimInfo><div>Bitte geben Sie für die Ebenen die verbaute Fläche inkl. Gemäuer an (außen gemessen).</div></ng-template>
    <div><br>Mit den Pfeil-Symbolen können Sie Ebenen hinzufügen und entfernen. Mit den Plus-Symbolen fügen Sie Mansarde und Keller hinzu.</div>
    <div class="hv-daten-builder-container">
      <div class="hv-daten-builder-illustration-container">
        <div class="hv-daten-builder-illustration-controls">
          <div matTooltip="Stock hinzufügen" [class]="stockwerke < 3 ? 'hv-daten-builder-button' : 'hv-daten-builder-button-disabled'" (click)="addStockwerk()">
            <mat-icon>keyboard_arrow_up</mat-icon>
          </div>
          <div matTooltip="Stock entfernen" [class]="stockwerke > 1 ? 'hv-daten-builder-button' : 'hv-daten-builder-button-disabled'" (click)="removeStockwerk()">
            <mat-icon>keyboard_arrow_down</mat-icon>
          </div>
        </div>
        <img class="hv-daten-builder-illustration" src={{image}}>
      </div>

      <div class="hv-daten-builder-input-container">
        <div class="hv-daten-builder-input">
          <div matTooltip="Mansarde hinzufügen" class="hv-daten-builder-button" (click)="toggleMansarde()" *ngIf="!hasMansarde">
            <mat-icon>add</mat-icon>
          </div>
          <div matTooltip="Mansarde entfernen" class="hv-daten-builder-button-remove" (click)="toggleMansarde()" *ngIf="hasMansarde">
            <mat-icon>close</mat-icon>
          </div>
          <mat-form-field *ngIf="showMansardeFlaecheQm">
            <mat-label>Mansarde (m²)</mat-label>
            <input matInput id="mansardeFlaecheQm" formControlName="mansardeFlaecheQm">
            <mat-error *ngIf="mansardeFlaecheQm.hasError('required')">{{ 'INPUTREQUIRED' | translate }}</mat-error>
            <mat-error *ngIf="mansardeFlaecheQm.hasError('pattern')">{{ 'INPUTINVALID' | translate }}</mat-error>
            <mat-error *ngIf="!mansardeFlaecheQm.hasError('pattern') && mansardeFlaecheQm.hasError('min')">{{ 'MINVALUE' | translate:{'value': mansardeFlaecheQm.errors.min.min} }}</mat-error>
            <mat-error *ngIf="!mansardeFlaecheQm.hasError('pattern') && mansardeFlaecheQm.hasError('max')">{{ 'MAXVALUE' | translate:{'value': mansardeFlaecheQm.errors.max.max} }}</mat-error>
          </mat-form-field>
        </div>

        <div class="hv-daten-builder-input" *ngIf="showZweiterStockFlaecheQm">
          <div class="hv-daten-builder-button-dummy"></div>
          <mat-form-field>
            <mat-label>2. Stock (m²)</mat-label>
            <input matInput id="zweiterStockFlaecheQm" formControlName="zweiterStockFlaecheQm">
            <mat-error *ngIf="zweiterStockFlaecheQm.hasError('required')">{{ 'INPUTREQUIRED' | translate }}</mat-error>
            <mat-error *ngIf="zweiterStockFlaecheQm.hasError('pattern')">{{ 'INPUTINVALID' | translate }}</mat-error>
            <mat-error *ngIf="!zweiterStockFlaecheQm.hasError('pattern') && zweiterStockFlaecheQm.hasError('min')">{{ 'MINVALUE' | translate:{'value': zweiterStockFlaecheQm.errors.min.min} }}</mat-error>
            <mat-error *ngIf="!zweiterStockFlaecheQm.hasError('pattern') && zweiterStockFlaecheQm.hasError('max')">{{ 'MAXVALUE' | translate:{'value': zweiterStockFlaecheQm.errors.max.max} }}</mat-error>
          </mat-form-field>
        </div>

        <div class="hv-daten-builder-input" *ngIf="showErsterStockFlaecheQm">
          <div class="hv-daten-builder-button-dummy"></div>
          <mat-form-field>
            <mat-label>1. Stock (m²)</mat-label>
            <input matInput id="ersterStockFlaecheQm" formControlName="ersterStockFlaecheQm">
            <mat-error *ngIf="ersterStockFlaecheQm.hasError('required')">{{ 'INPUTREQUIRED' | translate }}</mat-error>
            <mat-error *ngIf="ersterStockFlaecheQm.hasError('pattern')">{{ 'INPUTINVALID' | translate }}</mat-error>
            <mat-error *ngIf="!ersterStockFlaecheQm.hasError('pattern') && ersterStockFlaecheQm.hasError('min')">{{ 'MINVALUE' | translate:{'value': ersterStockFlaecheQm.errors.min.min} }}</mat-error>
            <mat-error *ngIf="!ersterStockFlaecheQm.hasError('pattern') && ersterStockFlaecheQm.hasError('max')">{{ 'MAXVALUE' | translate:{'value': ersterStockFlaecheQm.errors.max.max} }}</mat-error>
          </mat-form-field>
        </div>

        <div class="hv-daten-builder-input">
          <div class="hv-daten-builder-button-dummy"></div>
          <mat-form-field *ngIf="showErdgeschossFlaecheQm">
            <mat-label>Erdgeschoß (m²)</mat-label>
            <input matInput id="erdgeschossFlaecheQm" formControlName="erdgeschossFlaecheQm">
            <mat-error *ngIf="erdgeschossFlaecheQm.hasError('required')">{{ 'INPUTREQUIRED' | translate }}</mat-error>
            <mat-error *ngIf="erdgeschossFlaecheQm.hasError('pattern')">{{ 'INPUTINVALID' | translate }}</mat-error>
            <mat-error *ngIf="!erdgeschossFlaecheQm.hasError('pattern') && erdgeschossFlaecheQm.hasError('min')">{{ 'MINVALUE' | translate:{'value': erdgeschossFlaecheQm.errors.min.min} }}</mat-error>
            <mat-error *ngIf="!erdgeschossFlaecheQm.hasError('pattern') && erdgeschossFlaecheQm.hasError('max')">{{ 'MAXVALUE' | translate:{'value': erdgeschossFlaecheQm.errors.max.max} }}</mat-error>
          </mat-form-field>
        </div>

        <div class="hv-daten-builder-input">
          <div matTooltip="Keller hinzufügen" class="hv-daten-builder-button" (click)="toggleKeller()" *ngIf="!hasKeller">
            <mat-icon>add</mat-icon>
          </div>
          <div matTooltip="Keller entfernen" class="hv-daten-builder-button-remove" (click)="toggleKeller()" *ngIf="hasKeller">
            <mat-icon>close</mat-icon>
          </div>
          <mat-form-field *ngIf="showKellerFlaecheQm">
            <mat-label>Keller (m²)</mat-label>
            <input matInput id="kellerFlaecheQm" formControlName="kellerFlaecheQm">
            <mat-error *ngIf="kellerFlaecheQm.hasError('required')">{{ 'INPUTREQUIRED' | translate }}</mat-error>
            <mat-error *ngIf="kellerFlaecheQm.hasError('pattern')">{{ 'INPUTINVALID' | translate }}</mat-error>
            <mat-error *ngIf="!kellerFlaecheQm.hasError('pattern') && kellerFlaecheQm.hasError('min')">{{ 'MINVALUE' | translate:{'value': kellerFlaecheQm.errors.min.min} }}</mat-error>
            <mat-error *ngIf="!kellerFlaecheQm.hasError('pattern') && kellerFlaecheQm.hasError('max')">{{ 'MAXVALUE' | translate:{'value': kellerFlaecheQm.errors.max.max} }}</mat-error>
          </mat-form-field>
        </div>

        <div class="hv-daten-builder-input">
          <div class="hv-daten-builder-button-dummy"></div>
          <div class="hv-daten-builder-wohnkeller-container" *ngIf="showWohnKellerFlaecheQm">
            <div class="text_info">
              <label>davon zu Wohnzwecken:</label>
              <div class="info">
                <div class="info_trigger icon--before icon--info" *ngIf="(translateService.get('WOHNKELLERFLAECHEINFO') | async) as res" (click)="popupService.openInfoPopup(res)"></div>
              </div>
            </div>
            <mat-form-field>
              <mat-label>Wohnkeller (m²)</mat-label>
              <input matInput id="wohnkellerFlaecheQm" formControlName="wohnkellerFlaecheQm">
              <mat-error *ngIf="wohnkellerFlaecheQm.hasError('required')">{{ 'INPUTREQUIRED' | translate }}</mat-error>
              <mat-error *ngIf="wohnkellerFlaecheQm.hasError('pattern')">{{ 'INPUTINVALID' | translate }}</mat-error>
              <mat-error *ngIf="!wohnkellerFlaecheQm.hasError('pattern') && wohnkellerFlaecheQm.hasError('min')">{{ 'MINVALUE' | translate:{'value': wohnkellerFlaecheQm.errors.min.min} }}</mat-error>
              <mat-error *ngIf="!wohnkellerFlaecheQm.hasError('pattern') && !wohnkellerFlaecheQm.hasError('required') && wohnkellerFlaecheQm.hasError('max')">{{ 'MAXVALUE' | translate:{'value': kellerFlaecheQm.value ? kellerFlaecheQm.value : 0} }}</mat-error>
            </mat-form-field>
          </div>
        </div>
      </div>
    </div>
  </div>
</form>
